import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

import en_US from './en_US';

const DEFAULT_LANG = 'en_US'

const locales = {
    'en_US': en_US
}

export const i18n = new VueI18n({

    locale: DEFAULT_LANG,
    messages: locales,
})

export const langSetup = lang => {
    Object.keys(locales).forEach(lang => {
        document.body.classList.remove(`lang-${lang}`)
    })
    document.body.classList.add(`lang-${lang}`)
    document.body.setAttribute('lang', lang)
    Vue.config.lang = lang
    i18n.locale = lang
}

// window.i18n = i18n;